import React from "react";
import ReactDOM from "react-dom";

import ProductListing from "./productListingApp/productListing";

let root = document.getElementById("root");

console.log(root.dataset.breadcrumbs);

ReactDOM.render(
	<ProductListing id={root.dataset.categoryentryid} name={root.dataset.categoryname} breadcrumbs={root.dataset.breadcrumbs}/>,
	root
);